'use server'

import { apiRequest } from '../request'
import { Role, PermissionsMap } from '../common/interfaces/role.interface'

export const getRoles = async () => {
    return await apiRequest<Role[]>('roles', {})
}

export const getRole = async (id: number) => {
    return await apiRequest<Role>('roles', { id: String(id) })
}

/**
 * Role padrão da organização para um tipo de usuário (ex.: 'PROFESSIONAL'). Usa a MESMA
 * consulta que o backend faz ao impor o perfil — fonte de verdade confiável, diferente de
 * `getRoles`, cuja lista é filtrada por isSystem/partnerId e pode esconder a role padrão.
 */
export const getDefaultRole = async (userType: string) => {
    return await apiRequest<Role | null>('roles/default', {
        params: { userType },
    })
}

export const getPermissionsMap = async () => {
    return await apiRequest<PermissionsMap>('roles/permissions-map', {})
}

export const createRole = async (data: {
    name: string
    description?: string
    permissions: Record<string, any>
    defaultForType?: string | null
}) => {
    return await apiRequest<Role>('roles', { data }, 'post')
}

export const updateRole = async (
    id: number,
    data: {
        name?: string
        description?: string
        permissions?: Record<string, any>
        defaultForType?: string | null
    }
) => {
    return await apiRequest<Role>('roles', { id: String(id), data }, 'patch')
}

export const deleteRole = async (id: number) => {
    return await apiRequest<Role>('roles', { id: String(id) }, 'delete')
}

export const setRoleDefault = async (
    id: number,
    defaultForType: string | null
) => {
    return await apiRequest<Role>(
        `roles/${id}/default`,
        { data: { defaultForType } },
        'patch'
    )
}

export const assignRole = async (id: number, userIds: number[]) => {
    return await apiRequest<{ message: string; updatedCount: number }>(
        `roles/${id}/assign`,
        { data: { userIds } },
        'post'
    )
}
